import { v4 as uuid } from 'uuid';

const winCoefSizes = [
  {
    range: [1, 2],
    size: 'xs'
  },
  {
    range: [2, 5],
    size: 's'
  },
  {
    range: [5, 10],
    size: 'm'
  },
  {
    range: [10, 20],
    size: 'l'
  },
  {
    range: [20, Infinity],
    size: 'xl'
  }
];

const getWinCoefSize = (winCoef: number) => {
  return (
    winCoefSizes.find(
      ({ range }) => Number(winCoef) >= range[0] && Number(winCoef) < range[1]
    )?.size || 'xs'
  );
};

const formatWinCoef = (winCoef: number) => {
  let formattedNum = winCoef.toFixed(2);

  if (formattedNum.length > 5) {
    formattedNum = winCoef.toFixed(1);
  }

  // If still longer than 5 characters, remove decimal part entirely
  if (formattedNum.length > 5) {
    formattedNum = Math.round(winCoef).toString();
  }

  // If even the integer part is longer than 5 characters, just take the first 5 characters
  return formattedNum.length > 5 ? formattedNum.slice(0, 5) : formattedNum;
};

export const preparePragmaticGameResults = (results: number[] = []) =>
  results
    .filter((res) => res)
    .slice(0, 5)
    .map((result) => ({
      winCoef: formatWinCoef(result),
      coefSize: getWinCoefSize(result),
      id: uuid()
    }));
